import { CachingCollection } from "../../../collections/_BaseCollection";

export class BaseAnalyticsCollection<TModel extends Backbone.Model> extends CachingCollection<TModel> {
    appUrlRoot = 'analytics';
}


// WEBPACK FOOTER //
// ./srv/public/js/apps/analytics/collections/_BaseAnalyticsCollection.ts